import { render, staticRenderFns } from "./rate-warning.vue?vue&type=template&id=5267f23c&scoped=true"
import script from "./rate-warning.vue?vue&type=script&lang=js"
export * from "./rate-warning.vue?vue&type=script&lang=js"
import style0 from "./rate-warning.vue?vue&type=style&index=0&id=5267f23c&prod&lang=scss&scoped=true"
import style1 from "./rate-warning.vue?vue&type=style&index=1&id=5267f23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267f23c",
  null
  
)

export default component.exports